<div class="search-bar-container">
  <div class="search-child">
    <mat-label class="search-label">{{ searchValues.label }}</mat-label>
    <mat-form-field appearance="outline" class="search-field" floatLabel="always">
      <input
        matInput
        [placeholder]="placeholder"
        [value]="searchvalue"
        (keyup)="onKeyup($event)"
      />
      <button
        mat-icon-button
        matSuffix
        *ngIf="!searchvalue"
        disabled
      >
        <mat-icon>search</mat-icon>
      </button>
      <button
        mat-icon-button
        matSuffix
        *ngIf="searchvalue"
        (click)="clear()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
</div>
